import React, { useEffect, useState } from "react";
import api from "../../services/api";

const ModalCreerProduit = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ nom: "", description: "", montant_max: "", duree: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/produits", {
        nom: form.nom,
        description: form.description,
        montantMax: parseInt(form.montant_max),
        duree: parseInt(form.duree),
      });
      onSuccess("Produit créé avec succès !");
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de la création");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: "100%", padding: "0.65rem 0.9rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "0.75rem" };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Nouveau produit</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Nom du produit *</label>
          <input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Ex: Cash24" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Description</label>
          <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Description du produit..." rows={3}
            style={{ ...inputStyle, resize: "none" }} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Montant max (F CFA) *</label>
          <input type="number" value={form.montant_max} onChange={e => setForm({ ...form, montant_max: e.target.value })} placeholder="Ex: 100000" required min={1} style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Durée (heures) *</label>
          <input type="number" value={form.duree} onChange={e => setForm({ ...form, duree: e.target.value })} placeholder="Ex: 24" required min={1} style={inputStyle} />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: "0.5rem" }}>
            {loading ? "Création..." : "Créer le produit"}
          </button>
        </form>
      </div>
    </div>
  );
};

const Produits = () => {
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [search, setSearch] = useState("");

  const fetchProduits = async () => {
    try {
      const res = await api.get("/produits");
      setProduits(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProduits(); }, []);

  const handleSuccess = (msg) => {
    setShowModal(false);
    setSuccessMsg(msg);
    fetchProduits();
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  const produitsFiltres = produits.filter(p =>
    p.nom.toLowerCase().includes(search.toLowerCase()) ||
    (p.description || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      {showModal && <ModalCreerProduit onClose={() => setShowModal(false)} onSuccess={handleSuccess} />}

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Produits</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>
            {produitsFiltres.length} / {produits.length} produit(s)
          </p>
        </div>
        <button onClick={() => setShowModal(true)} style={{ padding: "0.6rem 1.25rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "9999px", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
          <svg width="14" height="14" fill="none" stroke="white" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Nouveau produit
        </button>
      </div>

      {/* Stats rapides */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "12px", marginBottom: "1.25rem" }}>
        <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
          <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px" }}>Total produits</div>
          <div style={{ fontSize: "22px", fontWeight: "500", color: "#7c3aed" }}>{produits.length}</div>
        </div>
        <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
          <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px" }}>Montant max le + élevé</div>
          <div style={{ fontSize: "18px", fontWeight: "500", color: "#185FA5" }}>
            {produits.length > 0 ? `${Math.max(...produits.map(p => Number(p.montant_max))).toLocaleString("fr-FR")} F` : "—"}
          </div>
        </div>
        <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
          <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px" }}>Durée la + longue</div>
          <div style={{ fontSize: "22px", fontWeight: "500", color: "#0f6e56" }}>
            {produits.length > 0 ? `${Math.max(...produits.map(p => Number(p.duree)))}h` : "—"}
          </div>
        </div>
      </div>

      {/* Barre de recherche */}
      <div style={{ position: "relative", marginBottom: "1.25rem" }}>
        <svg width="14" height="14" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24"
          style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}>
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" placeholder="Rechercher par nom ou description..."
          value={search} onChange={e => setSearch(e.target.value)}
          style={{ width: "100%", padding: "0.65rem 0.9rem 0.65rem 2.25rem", border: "1px solid #e5e7eb", borderRadius: "9999px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white" }} />
        {search && (
          <button onClick={() => setSearch("")} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: "16px" }}>×</button>
        )}
      </div>

      {successMsg && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>{successMsg}</div>
      )}

      {/* Grille produits */}
      {loading ? (
        <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
      ) : produitsFiltres.length === 0 ? (
        <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "3rem", textAlign: "center" }}>
          <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>📦</div>
          <p style={{ color: "#6b7280", fontSize: "14px" }}>{search ? "Aucun produit trouvé" : "Aucun produit"}</p>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "12px" }}>
          {produitsFiltres.map(produit => (
            <div key={produit.id} style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem", transition: "box-shadow 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "0.75rem" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "12px", background: "linear-gradient(135deg, #7c3aed, #9333ea)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                  📦
                </div>
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>{produit.nom}</div>
                  <div style={{ fontSize: "11px", color: "#9ca3af" }}>ID #{produit.id}</div>
                </div>
              </div>

              {produit.description && (
                <p style={{ fontSize: "12px", color: "#6b7280", margin: "0 0 1rem", lineHeight: 1.5, borderLeft: "3px solid #f3e8ff", paddingLeft: "8px" }}>
                  {produit.description}
                </p>
              )}

              <div style={{ display: "flex", gap: "1rem", borderTop: "0.5px solid #f3f4f6", paddingTop: "0.75rem" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "2px" }}>MONTANT MAX</div>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: "#7c3aed" }}>
                    {Number(produit.montant_max).toLocaleString("fr-FR")} F
                  </div>
                </div>
                <div style={{ width: "1px", backgroundColor: "#f3f4f6" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "2px" }}>DURÉE</div>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: "#185FA5" }}>
                    {produit.duree}h
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Produits;